import { useMemo } from 'react';
import useOneWayIn from '../../hooks/use-one-way-in';

const useOrgInfo = (formId: string) => {
  const { oneWayInGroupedFormWOEnrollmentsQuery } = useOneWayIn(formId);
  const { oneWayInOpportunityById } = useOneWayIn(formId);

  const { organizationNumber, organizationName } = useMemo(() => {
    let organizationNumber = '';
    if (
      oneWayInOpportunityById.data?.organizationNumber &&
      oneWayInOpportunityById.data?.organizationNumber.length === 9
    ) {
      if (oneWayInOpportunityById.data?.organizationName) {
        return {
          organizationNumber: oneWayInOpportunityById.data.organizationNumber,
          organizationName: oneWayInOpportunityById.data.organizationName,
        };
      }
      organizationNumber = oneWayInOpportunityById.data.organizationNumber;
    }
    if (
      oneWayInGroupedFormWOEnrollmentsQuery.data?.organisasjon?.orgNr &&
      oneWayInGroupedFormWOEnrollmentsQuery.data?.organisasjon?.orgNr.length === 9
    ) {
      if (oneWayInGroupedFormWOEnrollmentsQuery.data?.organisasjon?.navn) {
        return {
          organizationNumber: oneWayInGroupedFormWOEnrollmentsQuery.data?.organisasjon?.orgNr,
          organizationName: oneWayInGroupedFormWOEnrollmentsQuery.data?.organisasjon?.navn,
        };
      }
      organizationNumber = oneWayInGroupedFormWOEnrollmentsQuery.data?.organisasjon?.orgNr;
    }
    return { organizationNumber: organizationNumber, organizationName: undefined };
  }, [oneWayInOpportunityById, oneWayInGroupedFormWOEnrollmentsQuery]);

  return { organizationNumber, organizationName };
};

export default useOrgInfo;
